/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MfaRouteImport } from './routes/mfa'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAlertsCenterRouteImport } from './routes/_app/alerts-center'
import { Route as AppApiKeysRouteImport } from './routes/_app/api-keys'
import { Route as AppBroadcastRouteImport } from './routes/_app/broadcast'
import { Route as AppChatsRouteImport } from './routes/_app/chats'
import { Route as AppContactsRouteImport } from './routes/_app/contacts'
import { Route as AppEventsRouteImport } from './routes/_app/events'
import { Route as AppExamplesRouteImport } from './routes/_app/examples'
import { Route as AppGroupsRouteImport } from './routes/_app/groups'
import { Route as AppMessagesRouteImport } from './routes/_app/messages'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppClientClientIdRouteImport } from './routes/_app/client/$clientId'
import { Route as AppClientsIndexRouteImport } from './routes/_app/clients/index'
import { Route as AppClientsMatrixRouteImport } from './routes/_app/clients/matrix'
import { Route as AppGroupGroupIdRouteImport } from './routes/_app/group.$groupId'
import { Route as AppModuleModuleIdRouteImport } from './routes/_app/module.$moduleId'
import { Route as AppSettingsIndexRouteImport } from './routes/_app/settings/index'
import { Route as AppSettingsAiRouteImport } from './routes/_app/settings/ai'
import { Route as AppSettingsGeneralRouteImport } from './routes/_app/settings/general'
import { Route as AppSettingsNotificationsRouteImport } from './routes/_app/settings/notifications'
import { Route as AppSettingsQuietRouteImport } from './routes/_app/settings/quiet'
import { Route as AppSettingsRolesRouteImport } from './routes/_app/settings/roles'
import { Route as AppSettingsTemplatesRouteImport } from './routes/_app/settings/templates'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsWhatsappRouteImport } from './routes/_app/settings/whatsapp'
import { Route as AppWhatsappIndexRouteImport } from './routes/_app/whatsapp/index'
import { Route as AppWhatsappTabRouteImport } from './routes/_app/whatsapp/$tab'
import { Route as AppWhatsappTelegramRouteImport } from './routes/_app/whatsapp/telegram'
import { Route as AppClientClientIdIndexRouteImport } from './routes/_app/client/$clientId/index'
import { Route as AppClientClientIdAlertsRouteImport } from './routes/_app/client/$clientId/alerts'
import { Route as AppClientClientIdGroupsRouteImport } from './routes/_app/client/$clientId/groups'
import { Route as AppClientClientIdMessagesRouteImport } from './routes/_app/client/$clientId/messages'
import { Route as AppClientClientIdNivisionRouteImport } from './routes/_app/client/$clientId/nivision'
import { Route as AppClientClientIdPortalRouteImport } from './routes/_app/client/$clientId/portal'
import { Route as AppClientClientIdReportRouteImport } from './routes/_app/client/$clientId/report'
import { Route as AppClientClientIdSimulationRouteImport } from './routes/_app/client/$clientId/simulation'
import { Route as AppClientClientIdSummariesRouteImport } from './routes/_app/client/$clientId/summaries'
import { Route as AppClientsNewStepRouteImport } from './routes/_app/clients/new.$step'
import { Route as AppSettingsSegmentsIndexRouteImport } from './routes/_app/settings/segments.index'
import { Route as AppSettingsSegmentsSegmentRouteImport } from './routes/_app/settings/segments.$segment'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaRoute = MfaRouteImport.update({
  id: '/mfa',
  path: '/mfa',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAlertsCenterRoute = AppAlertsCenterRouteImport.update({
  id: '/alerts-center',
  path: '/alerts-center',
  getParentRoute: () => AppRoute,
} as any)
const AppApiKeysRoute = AppApiKeysRouteImport.update({
  id: '/api-keys',
  path: '/api-keys',
  getParentRoute: () => AppRoute,
} as any)
const AppBroadcastRoute = AppBroadcastRouteImport.update({
  id: '/broadcast',
  path: '/broadcast',
  getParentRoute: () => AppRoute,
} as any)
const AppChatsRoute = AppChatsRouteImport.update({
  id: '/chats',
  path: '/chats',
  getParentRoute: () => AppRoute,
} as any)
const AppContactsRoute = AppContactsRouteImport.update({
  id: '/contacts',
  path: '/contacts',
  getParentRoute: () => AppRoute,
} as any)
const AppEventsRoute = AppEventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => AppRoute,
} as any)
const AppExamplesRoute = AppExamplesRouteImport.update({
  id: '/examples',
  path: '/examples',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupsRoute = AppGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppRoute,
} as any)
const AppMessagesRoute = AppMessagesRouteImport.update({
  id: '/messages',
  path: '/messages',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppClientClientIdRoute = AppClientClientIdRouteImport.update({
  id: '/client/$clientId',
  path: '/client/$clientId',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsIndexRoute = AppClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AppRoute,
} as any)
const AppClientsMatrixRoute = AppClientsMatrixRouteImport.update({
  id: '/clients/matrix',
  path: '/clients/matrix',
  getParentRoute: () => AppRoute,
} as any)
const AppGroupGroupIdRoute = AppGroupGroupIdRouteImport.update({
  id: '/group/$groupId',
  path: '/group/$groupId',
  getParentRoute: () => AppRoute,
} as any)
const AppModuleModuleIdRoute = AppModuleModuleIdRouteImport.update({
  id: '/module/$moduleId',
  path: '/module/$moduleId',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsAiRoute = AppSettingsAiRouteImport.update({
  id: '/ai',
  path: '/ai',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsGeneralRoute = AppSettingsGeneralRouteImport.update({
  id: '/general',
  path: '/general',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsQuietRoute = AppSettingsQuietRouteImport.update({
  id: '/quiet',
  path: '/quiet',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsRolesRoute = AppSettingsRolesRouteImport.update({
  id: '/roles',
  path: '/roles',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsTemplatesRoute = AppSettingsTemplatesRouteImport.update({
  id: '/templates',
  path: '/templates',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppSettingsWhatsappRoute = AppSettingsWhatsappRouteImport.update({
  id: '/whatsapp',
  path: '/whatsapp',
  getParentRoute: () => AppSettingsRoute,
} as any)
const AppWhatsappIndexRoute = AppWhatsappIndexRouteImport.update({
  id: '/whatsapp/',
  path: '/whatsapp/',
  getParentRoute: () => AppRoute,
} as any)
const AppWhatsappTabRoute = AppWhatsappTabRouteImport.update({
  id: '/whatsapp/$tab',
  path: '/whatsapp/$tab',
  getParentRoute: () => AppRoute,
} as any)
const AppWhatsappTelegramRoute = AppWhatsappTelegramRouteImport.update({
  id: '/whatsapp/telegram',
  path: '/whatsapp/telegram',
  getParentRoute: () => AppRoute,
} as any)
const AppClientClientIdIndexRoute = AppClientClientIdIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClientClientIdRoute,
} as any)
const AppClientClientIdAlertsRoute = AppClientClientIdAlertsRouteImport.update({
  id: '/alerts',
  path: '/alerts',
  getParentRoute: () => AppClientClientIdRoute,
} as any)
const AppClientClientIdGroupsRoute = AppClientClientIdGroupsRouteImport.update({
  id: '/groups',
  path: '/groups',
  getParentRoute: () => AppClientClientIdRoute,
} as any)
const AppClientClientIdMessagesRoute =
  AppClientClientIdMessagesRouteImport.update({
    id: '/messages',
    path: '/messages',
    getParentRoute: () => AppClientClientIdRoute,
  } as any)
const AppClientClientIdNivisionRoute =
  AppClientClientIdNivisionRouteImport.update({
    id: '/nivision',
    path: '/nivision',
    getParentRoute: () => AppClientClientIdRoute,
  } as any)
const AppClientClientIdPortalRoute = AppClientClientIdPortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => AppClientClientIdRoute,
} as any)
const AppClientClientIdReportRoute = AppClientClientIdReportRouteImport.update({
  id: '/report',
  path: '/report',
  getParentRoute: () => AppClientClientIdRoute,
} as any)
const AppClientClientIdSimulationRoute =
  AppClientClientIdSimulationRouteImport.update({
    id: '/simulation',
    path: '/simulation',
    getParentRoute: () => AppClientClientIdRoute,
  } as any)
const AppClientClientIdSummariesRoute =
  AppClientClientIdSummariesRouteImport.update({
    id: '/summaries',
    path: '/summaries',
    getParentRoute: () => AppClientClientIdRoute,
  } as any)
const AppClientsNewStepRoute = AppClientsNewStepRouteImport.update({
  id: '/clients/new/$step',
  path: '/clients/new/$step',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSegmentsIndexRoute =
  AppSettingsSegmentsIndexRouteImport.update({
    id: '/segments/',
    path: '/segments/',
    getParentRoute: () => AppSettingsRoute,
  } as any)
const AppSettingsSegmentsSegmentRoute =
  AppSettingsSegmentsSegmentRouteImport.update({
    id: '/segments/$segment',
    path: '/segments/$segment',
    getParentRoute: () => AppSettingsRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/alerts-center': typeof AppAlertsCenterRoute
  '/api-keys': typeof AppApiKeysRoute
  '/broadcast': typeof AppBroadcastRoute
  '/chats': typeof AppChatsRoute
  '/contacts': typeof AppContactsRoute
  '/events': typeof AppEventsRoute
  '/examples': typeof AppExamplesRoute
  '/groups': typeof AppGroupsRoute
  '/messages': typeof AppMessagesRoute
  '/settings': typeof AppSettingsRouteWithChildren
  '/client/$clientId': typeof AppClientClientIdRouteWithChildren
  '/clients/matrix': typeof AppClientsMatrixRoute
  '/group/$groupId': typeof AppGroupGroupIdRoute
  '/module/$moduleId': typeof AppModuleModuleIdRoute
  '/settings/ai': typeof AppSettingsAiRoute
  '/settings/general': typeof AppSettingsGeneralRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/quiet': typeof AppSettingsQuietRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/templates': typeof AppSettingsTemplatesRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/whatsapp': typeof AppSettingsWhatsappRoute
  '/whatsapp/$tab': typeof AppWhatsappTabRoute
  '/whatsapp/telegram': typeof AppWhatsappTelegramRoute
  '/clients/': typeof AppClientsIndexRoute
  '/settings/': typeof AppSettingsIndexRoute
  '/whatsapp/': typeof AppWhatsappIndexRoute
  '/client/$clientId/alerts': typeof AppClientClientIdAlertsRoute
  '/client/$clientId/groups': typeof AppClientClientIdGroupsRoute
  '/client/$clientId/messages': typeof AppClientClientIdMessagesRoute
  '/client/$clientId/nivision': typeof AppClientClientIdNivisionRoute
  '/client/$clientId/portal': typeof AppClientClientIdPortalRoute
  '/client/$clientId/report': typeof AppClientClientIdReportRoute
  '/client/$clientId/simulation': typeof AppClientClientIdSimulationRoute
  '/client/$clientId/summaries': typeof AppClientClientIdSummariesRoute
  '/clients/new/$step': typeof AppClientsNewStepRoute
  '/settings/segments/$segment': typeof AppSettingsSegmentsSegmentRoute
  '/client/$clientId/': typeof AppClientClientIdIndexRoute
  '/settings/segments/': typeof AppSettingsSegmentsIndexRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/alerts-center': typeof AppAlertsCenterRoute
  '/api-keys': typeof AppApiKeysRoute
  '/broadcast': typeof AppBroadcastRoute
  '/chats': typeof AppChatsRoute
  '/contacts': typeof AppContactsRoute
  '/events': typeof AppEventsRoute
  '/examples': typeof AppExamplesRoute
  '/groups': typeof AppGroupsRoute
  '/messages': typeof AppMessagesRoute
  '/': typeof AppIndexRoute
  '/clients/matrix': typeof AppClientsMatrixRoute
  '/group/$groupId': typeof AppGroupGroupIdRoute
  '/module/$moduleId': typeof AppModuleModuleIdRoute
  '/settings/ai': typeof AppSettingsAiRoute
  '/settings/general': typeof AppSettingsGeneralRoute
  '/settings/notifications': typeof AppSettingsNotificationsRoute
  '/settings/quiet': typeof AppSettingsQuietRoute
  '/settings/roles': typeof AppSettingsRolesRoute
  '/settings/templates': typeof AppSettingsTemplatesRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/whatsapp': typeof AppSettingsWhatsappRoute
  '/whatsapp/$tab': typeof AppWhatsappTabRoute
  '/whatsapp/telegram': typeof AppWhatsappTelegramRoute
  '/clients': typeof AppClientsIndexRoute
  '/settings': typeof AppSettingsIndexRoute
  '/whatsapp': typeof AppWhatsappIndexRoute
  '/client/$clientId/alerts': typeof AppClientClientIdAlertsRoute
  '/client/$clientId/groups': typeof AppClientClientIdGroupsRoute
  '/client/$clientId/messages': typeof AppClientClientIdMessagesRoute
  '/client/$clientId/nivision': typeof AppClientClientIdNivisionRoute
  '/client/$clientId/portal': typeof AppClientClientIdPortalRoute
  '/client/$clientId/report': typeof AppClientClientIdReportRoute
  '/client/$clientId/simulation': typeof AppClientClientIdSimulationRoute
  '/client/$clientId/summaries': typeof AppClientClientIdSummariesRoute
  '/clients/new/$step': typeof AppClientsNewStepRoute
  '/settings/segments/$segment': typeof AppSettingsSegmentsSegmentRoute
  '/client/$clientId': typeof AppClientClientIdIndexRoute
  '/settings/segments': typeof AppSettingsSegmentsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/mfa': typeof MfaRoute
  '/_app/alerts-center': typeof AppAlertsCenterRoute
  '/_app/api-keys': typeof AppApiKeysRoute
  '/_app/broadcast': typeof AppBroadcastRoute
  '/_app/chats': typeof AppChatsRoute
  '/_app/contacts': typeof AppContactsRoute
  '/_app/events': typeof AppEventsRoute
  '/_app/examples': typeof AppExamplesRoute
  '/_app/groups': typeof AppGroupsRoute
  '/_app/messages': typeof AppMessagesRoute
  '/_app/settings': typeof AppSettingsRouteWithChildren
  '/_app/': typeof AppIndexRoute
  '/_app/client/$clientId': typeof AppClientClientIdRouteWithChildren
  '/_app/clients/matrix': typeof AppClientsMatrixRoute
  '/_app/group/$groupId': typeof AppGroupGroupIdRoute
  '/_app/module/$moduleId': typeof AppModuleModuleIdRoute
  '/_app/settings/ai': typeof AppSettingsAiRoute
  '/_app/settings/general': typeof AppSettingsGeneralRoute
  '/_app/settings/notifications': typeof AppSettingsNotificationsRoute
  '/_app/settings/quiet': typeof AppSettingsQuietRoute
  '/_app/settings/roles': typeof AppSettingsRolesRoute
  '/_app/settings/templates': typeof AppSettingsTemplatesRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/settings/whatsapp': typeof AppSettingsWhatsappRoute
  '/_app/whatsapp/$tab': typeof AppWhatsappTabRoute
  '/_app/whatsapp/telegram': typeof AppWhatsappTelegramRoute
  '/_app/clients/': typeof AppClientsIndexRoute
  '/_app/settings/': typeof AppSettingsIndexRoute
  '/_app/whatsapp/': typeof AppWhatsappIndexRoute
  '/_app/client/$clientId/alerts': typeof AppClientClientIdAlertsRoute
  '/_app/client/$clientId/groups': typeof AppClientClientIdGroupsRoute
  '/_app/client/$clientId/messages': typeof AppClientClientIdMessagesRoute
  '/_app/client/$clientId/nivision': typeof AppClientClientIdNivisionRoute
  '/_app/client/$clientId/portal': typeof AppClientClientIdPortalRoute
  '/_app/client/$clientId/report': typeof AppClientClientIdReportRoute
  '/_app/client/$clientId/simulation': typeof AppClientClientIdSimulationRoute
  '/_app/client/$clientId/summaries': typeof AppClientClientIdSummariesRoute
  '/_app/clients/new/$step': typeof AppClientsNewStepRoute
  '/_app/settings/segments/$segment': typeof AppSettingsSegmentsSegmentRoute
  '/_app/client/$clientId/': typeof AppClientClientIdIndexRoute
  '/_app/settings/segments/': typeof AppSettingsSegmentsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/mfa'
    | '/alerts-center'
    | '/api-keys'
    | '/broadcast'
    | '/chats'
    | '/contacts'
    | '/events'
    | '/examples'
    | '/groups'
    | '/messages'
    | '/settings'
    | '/client/$clientId'
    | '/clients/matrix'
    | '/group/$groupId'
    | '/module/$moduleId'
    | '/settings/ai'
    | '/settings/general'
    | '/settings/notifications'
    | '/settings/quiet'
    | '/settings/roles'
    | '/settings/templates'
    | '/settings/users'
    | '/settings/whatsapp'
    | '/whatsapp/$tab'
    | '/whatsapp/telegram'
    | '/clients/'
    | '/settings/'
    | '/whatsapp/'
    | '/client/$clientId/alerts'
    | '/client/$clientId/groups'
    | '/client/$clientId/messages'
    | '/client/$clientId/nivision'
    | '/client/$clientId/portal'
    | '/client/$clientId/report'
    | '/client/$clientId/simulation'
    | '/client/$clientId/summaries'
    | '/clients/new/$step'
    | '/settings/segments/$segment'
    | '/client/$clientId/'
    | '/settings/segments/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/mfa'
    | '/alerts-center'
    | '/api-keys'
    | '/broadcast'
    | '/chats'
    | '/contacts'
    | '/events'
    | '/examples'
    | '/groups'
    | '/messages'
    | '/'
    | '/clients/matrix'
    | '/group/$groupId'
    | '/module/$moduleId'
    | '/settings/ai'
    | '/settings/general'
    | '/settings/notifications'
    | '/settings/quiet'
    | '/settings/roles'
    | '/settings/templates'
    | '/settings/users'
    | '/settings/whatsapp'
    | '/whatsapp/$tab'
    | '/whatsapp/telegram'
    | '/clients'
    | '/settings'
    | '/whatsapp'
    | '/client/$clientId/alerts'
    | '/client/$clientId/groups'
    | '/client/$clientId/messages'
    | '/client/$clientId/nivision'
    | '/client/$clientId/portal'
    | '/client/$clientId/report'
    | '/client/$clientId/simulation'
    | '/client/$clientId/summaries'
    | '/clients/new/$step'
    | '/settings/segments/$segment'
    | '/client/$clientId'
    | '/settings/segments'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/mfa'
    | '/_app/alerts-center'
    | '/_app/api-keys'
    | '/_app/broadcast'
    | '/_app/chats'
    | '/_app/contacts'
    | '/_app/events'
    | '/_app/examples'
    | '/_app/groups'
    | '/_app/messages'
    | '/_app/settings'
    | '/_app/'
    | '/_app/client/$clientId'
    | '/_app/clients/matrix'
    | '/_app/group/$groupId'
    | '/_app/module/$moduleId'
    | '/_app/settings/ai'
    | '/_app/settings/general'
    | '/_app/settings/notifications'
    | '/_app/settings/quiet'
    | '/_app/settings/roles'
    | '/_app/settings/templates'
    | '/_app/settings/users'
    | '/_app/settings/whatsapp'
    | '/_app/whatsapp/$tab'
    | '/_app/whatsapp/telegram'
    | '/_app/clients/'
    | '/_app/settings/'
    | '/_app/whatsapp/'
    | '/_app/client/$clientId/alerts'
    | '/_app/client/$clientId/groups'
    | '/_app/client/$clientId/messages'
    | '/_app/client/$clientId/nivision'
    | '/_app/client/$clientId/portal'
    | '/_app/client/$clientId/report'
    | '/_app/client/$clientId/simulation'
    | '/_app/client/$clientId/summaries'
    | '/_app/clients/new/$step'
    | '/_app/settings/segments/$segment'
    | '/_app/client/$clientId/'
    | '/_app/settings/segments/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  MfaRoute: typeof MfaRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa': {
      id: '/mfa'
      path: '/mfa'
      fullPath: '/mfa'
      preLoaderRoute: typeof MfaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/alerts-center': {
      id: '/_app/alerts-center'
      path: '/alerts-center'
      fullPath: '/alerts-center'
      preLoaderRoute: typeof AppAlertsCenterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/api-keys': {
      id: '/_app/api-keys'
      path: '/api-keys'
      fullPath: '/api-keys'
      preLoaderRoute: typeof AppApiKeysRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/broadcast': {
      id: '/_app/broadcast'
      path: '/broadcast'
      fullPath: '/broadcast'
      preLoaderRoute: typeof AppBroadcastRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/chats': {
      id: '/_app/chats'
      path: '/chats'
      fullPath: '/chats'
      preLoaderRoute: typeof AppChatsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/contacts': {
      id: '/_app/contacts'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof AppContactsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/events': {
      id: '/_app/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof AppEventsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/examples': {
      id: '/_app/examples'
      path: '/examples'
      fullPath: '/examples'
      preLoaderRoute: typeof AppExamplesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/groups': {
      id: '/_app/groups'
      path: '/groups'
      fullPath: '/groups'
      preLoaderRoute: typeof AppGroupsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/messages': {
      id: '/_app/messages'
      path: '/messages'
      fullPath: '/messages'
      preLoaderRoute: typeof AppMessagesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/client/$clientId': {
      id: '/_app/client/$clientId'
      path: '/client/$clientId'
      fullPath: '/client/$clientId'
      preLoaderRoute: typeof AppClientClientIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/': {
      id: '/_app/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AppClientsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/clients/matrix': {
      id: '/_app/clients/matrix'
      path: '/clients/matrix'
      fullPath: '/clients/matrix'
      preLoaderRoute: typeof AppClientsMatrixRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/group/$groupId': {
      id: '/_app/group/$groupId'
      path: '/group/$groupId'
      fullPath: '/group/$groupId'
      preLoaderRoute: typeof AppGroupGroupIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/module/$moduleId': {
      id: '/_app/module/$moduleId'
      path: '/module/$moduleId'
      fullPath: '/module/$moduleId'
      preLoaderRoute: typeof AppModuleModuleIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/': {
      id: '/_app/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/ai': {
      id: '/_app/settings/ai'
      path: '/ai'
      fullPath: '/settings/ai'
      preLoaderRoute: typeof AppSettingsAiRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/general': {
      id: '/_app/settings/general'
      path: '/general'
      fullPath: '/settings/general'
      preLoaderRoute: typeof AppSettingsGeneralRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/notifications': {
      id: '/_app/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/quiet': {
      id: '/_app/settings/quiet'
      path: '/quiet'
      fullPath: '/settings/quiet'
      preLoaderRoute: typeof AppSettingsQuietRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/roles': {
      id: '/_app/settings/roles'
      path: '/roles'
      fullPath: '/settings/roles'
      preLoaderRoute: typeof AppSettingsRolesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/templates': {
      id: '/_app/settings/templates'
      path: '/templates'
      fullPath: '/settings/templates'
      preLoaderRoute: typeof AppSettingsTemplatesRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/whatsapp': {
      id: '/_app/settings/whatsapp'
      path: '/whatsapp'
      fullPath: '/settings/whatsapp'
      preLoaderRoute: typeof AppSettingsWhatsappRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/whatsapp/': {
      id: '/_app/whatsapp/'
      path: '/whatsapp'
      fullPath: '/whatsapp/'
      preLoaderRoute: typeof AppWhatsappIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/whatsapp/$tab': {
      id: '/_app/whatsapp/$tab'
      path: '/whatsapp/$tab'
      fullPath: '/whatsapp/$tab'
      preLoaderRoute: typeof AppWhatsappTabRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/whatsapp/telegram': {
      id: '/_app/whatsapp/telegram'
      path: '/whatsapp/telegram'
      fullPath: '/whatsapp/telegram'
      preLoaderRoute: typeof AppWhatsappTelegramRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/client/$clientId/': {
      id: '/_app/client/$clientId/'
      path: '/'
      fullPath: '/client/$clientId/'
      preLoaderRoute: typeof AppClientClientIdIndexRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/client/$clientId/alerts': {
      id: '/_app/client/$clientId/alerts'
      path: '/alerts'
      fullPath: '/client/$clientId/alerts'
      preLoaderRoute: typeof AppClientClientIdAlertsRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/client/$clientId/groups': {
      id: '/_app/client/$clientId/groups'
      path: '/groups'
      fullPath: '/client/$clientId/groups'
      preLoaderRoute: typeof AppClientClientIdGroupsRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/client/$clientId/messages': {
      id: '/_app/client/$clientId/messages'
      path: '/messages'
      fullPath: '/client/$clientId/messages'
      preLoaderRoute: typeof AppClientClientIdMessagesRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/client/$clientId/nivision': {
      id: '/_app/client/$clientId/nivision'
      path: '/nivision'
      fullPath: '/client/$clientId/nivision'
      preLoaderRoute: typeof AppClientClientIdNivisionRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/client/$clientId/portal': {
      id: '/_app/client/$clientId/portal'
      path: '/portal'
      fullPath: '/client/$clientId/portal'
      preLoaderRoute: typeof AppClientClientIdPortalRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/client/$clientId/report': {
      id: '/_app/client/$clientId/report'
      path: '/report'
      fullPath: '/client/$clientId/report'
      preLoaderRoute: typeof AppClientClientIdReportRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/client/$clientId/simulation': {
      id: '/_app/client/$clientId/simulation'
      path: '/simulation'
      fullPath: '/client/$clientId/simulation'
      preLoaderRoute: typeof AppClientClientIdSimulationRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/client/$clientId/summaries': {
      id: '/_app/client/$clientId/summaries'
      path: '/summaries'
      fullPath: '/client/$clientId/summaries'
      preLoaderRoute: typeof AppClientClientIdSummariesRouteImport
      parentRoute: typeof AppClientClientIdRoute
    }
    '/_app/clients/new/$step': {
      id: '/_app/clients/new/$step'
      path: '/clients/new/$step'
      fullPath: '/clients/new/$step'
      preLoaderRoute: typeof AppClientsNewStepRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/segments/': {
      id: '/_app/settings/segments/'
      path: '/segments'
      fullPath: '/settings/segments/'
      preLoaderRoute: typeof AppSettingsSegmentsIndexRouteImport
      parentRoute: typeof AppSettingsRoute
    }
    '/_app/settings/segments/$segment': {
      id: '/_app/settings/segments/$segment'
      path: '/segments/$segment'
      fullPath: '/settings/segments/$segment'
      preLoaderRoute: typeof AppSettingsSegmentsSegmentRouteImport
      parentRoute: typeof AppSettingsRoute
    }
  }
}

interface AppSettingsRouteChildren {
  AppSettingsAiRoute: typeof AppSettingsAiRoute
  AppSettingsGeneralRoute: typeof AppSettingsGeneralRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsQuietRoute: typeof AppSettingsQuietRoute
  AppSettingsRolesRoute: typeof AppSettingsRolesRoute
  AppSettingsTemplatesRoute: typeof AppSettingsTemplatesRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppSettingsWhatsappRoute: typeof AppSettingsWhatsappRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
  AppSettingsSegmentsSegmentRoute: typeof AppSettingsSegmentsSegmentRoute
  AppSettingsSegmentsIndexRoute: typeof AppSettingsSegmentsIndexRoute
}

const AppSettingsRouteChildren: AppSettingsRouteChildren = {
  AppSettingsAiRoute: AppSettingsAiRoute,
  AppSettingsGeneralRoute: AppSettingsGeneralRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsQuietRoute: AppSettingsQuietRoute,
  AppSettingsRolesRoute: AppSettingsRolesRoute,
  AppSettingsTemplatesRoute: AppSettingsTemplatesRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppSettingsWhatsappRoute: AppSettingsWhatsappRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
  AppSettingsSegmentsSegmentRoute: AppSettingsSegmentsSegmentRoute,
  AppSettingsSegmentsIndexRoute: AppSettingsSegmentsIndexRoute,
}

const AppSettingsRouteWithChildren = AppSettingsRoute._addFileChildren(
  AppSettingsRouteChildren,
)

interface AppClientClientIdRouteChildren {
  AppClientClientIdAlertsRoute: typeof AppClientClientIdAlertsRoute
  AppClientClientIdGroupsRoute: typeof AppClientClientIdGroupsRoute
  AppClientClientIdMessagesRoute: typeof AppClientClientIdMessagesRoute
  AppClientClientIdNivisionRoute: typeof AppClientClientIdNivisionRoute
  AppClientClientIdPortalRoute: typeof AppClientClientIdPortalRoute
  AppClientClientIdReportRoute: typeof AppClientClientIdReportRoute
  AppClientClientIdSimulationRoute: typeof AppClientClientIdSimulationRoute
  AppClientClientIdSummariesRoute: typeof AppClientClientIdSummariesRoute
  AppClientClientIdIndexRoute: typeof AppClientClientIdIndexRoute
}

const AppClientClientIdRouteChildren: AppClientClientIdRouteChildren = {
  AppClientClientIdAlertsRoute: AppClientClientIdAlertsRoute,
  AppClientClientIdGroupsRoute: AppClientClientIdGroupsRoute,
  AppClientClientIdMessagesRoute: AppClientClientIdMessagesRoute,
  AppClientClientIdNivisionRoute: AppClientClientIdNivisionRoute,
  AppClientClientIdPortalRoute: AppClientClientIdPortalRoute,
  AppClientClientIdReportRoute: AppClientClientIdReportRoute,
  AppClientClientIdSimulationRoute: AppClientClientIdSimulationRoute,
  AppClientClientIdSummariesRoute: AppClientClientIdSummariesRoute,
  AppClientClientIdIndexRoute: AppClientClientIdIndexRoute,
}

const AppClientClientIdRouteWithChildren =
  AppClientClientIdRoute._addFileChildren(AppClientClientIdRouteChildren)

interface AppRouteChildren {
  AppAlertsCenterRoute: typeof AppAlertsCenterRoute
  AppApiKeysRoute: typeof AppApiKeysRoute
  AppBroadcastRoute: typeof AppBroadcastRoute
  AppChatsRoute: typeof AppChatsRoute
  AppContactsRoute: typeof AppContactsRoute
  AppEventsRoute: typeof AppEventsRoute
  AppExamplesRoute: typeof AppExamplesRoute
  AppGroupsRoute: typeof AppGroupsRoute
  AppMessagesRoute: typeof AppMessagesRoute
  AppSettingsRoute: typeof AppSettingsRouteWithChildren
  AppIndexRoute: typeof AppIndexRoute
  AppClientClientIdRoute: typeof AppClientClientIdRouteWithChildren
  AppClientsMatrixRoute: typeof AppClientsMatrixRoute
  AppGroupGroupIdRoute: typeof AppGroupGroupIdRoute
  AppModuleModuleIdRoute: typeof AppModuleModuleIdRoute
  AppWhatsappTabRoute: typeof AppWhatsappTabRoute
  AppWhatsappTelegramRoute: typeof AppWhatsappTelegramRoute
  AppClientsIndexRoute: typeof AppClientsIndexRoute
  AppWhatsappIndexRoute: typeof AppWhatsappIndexRoute
  AppClientsNewStepRoute: typeof AppClientsNewStepRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAlertsCenterRoute: AppAlertsCenterRoute,
  AppApiKeysRoute: AppApiKeysRoute,
  AppBroadcastRoute: AppBroadcastRoute,
  AppChatsRoute: AppChatsRoute,
  AppContactsRoute: AppContactsRoute,
  AppEventsRoute: AppEventsRoute,
  AppExamplesRoute: AppExamplesRoute,
  AppGroupsRoute: AppGroupsRoute,
  AppMessagesRoute: AppMessagesRoute,
  AppSettingsRoute: AppSettingsRouteWithChildren,
  AppIndexRoute: AppIndexRoute,
  AppClientClientIdRoute: AppClientClientIdRouteWithChildren,
  AppClientsMatrixRoute: AppClientsMatrixRoute,
  AppGroupGroupIdRoute: AppGroupGroupIdRoute,
  AppModuleModuleIdRoute: AppModuleModuleIdRoute,
  AppWhatsappTabRoute: AppWhatsappTabRoute,
  AppWhatsappTelegramRoute: AppWhatsappTelegramRoute,
  AppClientsIndexRoute: AppClientsIndexRoute,
  AppWhatsappIndexRoute: AppWhatsappIndexRoute,
  AppClientsNewStepRoute: AppClientsNewStepRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  MfaRoute: MfaRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
